import validator from "validator"

export const MOSTRA_BANNERS = true
export const MOSTRA_PROMOCOES = false
export const MOSTRA_MARCAS = true

const CAMINHO_FOTOS = 'https://traderotasagrope1.websiteseguro.com/fotos/arco/'
//CAMINHO_FOTOS = 'https://traderotasagrope1.websiteseguro.com/fotos/arco/' //<-NO PC DO Arco Iris Tintas

//if (window.location.href.search('192.168.0.200') != -1) { CAMINHO_FOTOS = 'http://192.168.0.200:2243/fotos3/' }

export { CAMINHO_FOTOS };
export const CAMINHO_CLASSIFICADOS = 'http://187.86.147.193:8081/site/src/img/classificados/'
export const CAMINHO_PROMOCOES = 'http://187.86.147.193:8081/site/src/img/promocoes'
export const MULTI_EMPRESA = false